import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import IssuerConfigTable from "./components/IssuerConfigTable";
import PageHeader from "../../../shared/components/PageHeader";
import { getAllIssuerConfigs, resetConfigs } from "../actions/issuerConfig.actions";
import { permissionsConstants } from "../../../constants/permissions.constants";
import { formValueSelector } from "redux-form";

const IssuerConfigList = (props) => {
    const { dispatch, issuerConfigs, assignedIssuer, permissions, selectedIssuer } = props;

    const userPermissions = permissions && permissions.map((permission) => permission.authority);

    const isAdmin = userPermissions && userPermissions.includes(permissionsConstants.FETCH_ISSUER_CONFIGS);

    const issuer = isAdmin ? selectedIssuer : assignedIssuer;
    const getIssuersConfigALL = () => {
        if (issuer) {
            dispatch(getAllIssuerConfigs(issuer, { page: 1, pageSize: 10 }));
        } else {
            dispatch(resetConfigs());
        }
    };
    const loadConfigs = (pageState) => {
        dispatch(getAllIssuerConfigs(issuer, pageState));
    };

    useEffect(() => {
        if (issuer) {
            dispatch(getAllIssuerConfigs(issuer, { page: 1, pageSize: 10 }));
        } else {
            dispatch(resetConfigs());
        }
    }, [dispatch, issuer]);

    return (
        <Container>
            <PageHeader header="Manage Issuer Configurations" subheader="Manage issuer configurations for faster card creation" />
            <Row>
                <IssuerConfigTable dataState={issuerConfigs} fetchData={loadConfigs} getIssuersConfigALL={getIssuersConfigALL} />
            </Row>
        </Container>
    );
};

const selector = formValueSelector("fetchConfigs");

export default connect((state) => ({
    selectedIssuer: selector(state, "scpIssuers"),
    issuerConfigs: state.getAllIssuerConfig,
    permissions: state.permissions && state.permissions.response,
    assignedIssuer: state.getIssuerDomainMapping && state.getIssuerDomainMapping.response && state.getIssuerDomainMapping.response.data ? state.getIssuerDomainMapping.response.data[0] : [],
}))(IssuerConfigList);
